import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useMe } from '@/hooks/use-me';
import type { Rol } from '@/types/api';

// Mismo ranking que backend/src/auth/middleware.ts (mismo nombre y mismos
// valores, contrato manual entre back y front): viewer < gestor < admin.
const ROL_RANK: Record<Rol, number> = { viewer: 0, gestor: 1, admin: 2 };

interface Props {
  min: Rol;
  children: ReactNode;
}

// Gate de rol genérico (decisión Juan 2026-07-10): generaliza RequireAdmin a
// un umbral cualquiera (acá lo usa /gestion con min="gestor"). RequireAdmin
// NO se toca ni se refactoriza para reusar esto por dentro — sigue en pie
// tal cual para Administración/Auditoría (otro ejecutor lo sigue usando);
// son dos gates hermanos, mismo patrón, sin dependencia entre sí.
export function RequireRole({ min, children }: Props) {
  const { data: user } = useMe();
  if (!user || ROL_RANK[user.rol] < ROL_RANK[min]) return <Navigate to="/" replace />;
  return <>{children}</>;
}
